import React from 'react';
import { useTranslation } from 'react-i18next';

import ViewerIcon from '../ViewerIcon';
import { ZoomIn as ZoomInIcon, ZoomOut as ZoomOutIcon } from '../../icons';

import styles from './Zoom.module.scss';

export type ZoomProps = {
  zoomIn: () => void;
  zoomOut: () => void;
};

const Zoom: React.FC<ZoomProps> = React.memo((props) => {
  const [t] = useTranslation();
  return (
    <div className={styles.ff_zoom} data-testid='zoom-section'>
      <ViewerIcon data-testid='zoom-in' cssClass={styles.ff_zoom__zoom_in} onClick={() => props.zoomIn()}>
        <ZoomInIcon />
      </ViewerIcon>
      <div className={styles.ff_zoom__description}>{t('ZOOM')}</div>
      <ViewerIcon data-testid='zoom-out' cssClass={styles.ff_zoom__zoom_out} onClick={() => props.zoomOut()}>
        <ZoomOutIcon />
      </ViewerIcon>
    </div>
  );
});

export default Zoom;
